export default "__VITE_ASSET__VGY9n5DH__"